import { put } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

const requestSchema = z.object({
  isEarlyClockInEnabled: z.boolean(),
});

const responseSchema = z.string();

interface UseUpdateEarlyClockInParams {
  facilityId: string;
  isEarlyClockInEnabled: boolean;
}

const UPDATE_EARLY_CLOCK_IN_FAILURE = "Settings Redesign: Update Early Clock In Failure";

export function useUpdateEarlyClockIn() {
  return useMutation({
    mutationFn: async (parameters: UseUpdateEarlyClockInParams) => {
      const response = await put({
        url: `${environmentConfig.REACT_APP_API_MAIN_URL}/api/facilityprofile/${parameters.facilityId}/update-early-clock-in-enabled`,
        data: { isEarlyClockInEnabled: parameters.isEarlyClockInEnabled },
        bodySchema: requestSchema,
        responseSchema,
      });

      return response.data;
    },
    meta: { logErrorMessage: UPDATE_EARLY_CLOCK_IN_FAILURE },
  });
}
